import { createActions, createReducer } from 'reduxsauce'
import labels from '../components/Filtro/Labels'

const meses = [
    { value: '1', label: labels['janeiro'] },
    { value: '2', label: labels['fevereiro'] },
    { value: '3', label: labels['marco'] },
    { value: '4', label: labels['abril'] },
    { value: '5', label: labels['maio'] },
    { value: '6', label: labels['junho'] },
    { value: '7', label: labels['julho'] },
    { value: '8', label: labels['agosto'] },
    { value: '9', label: labels['setembro'] },
    { value: '10', label: labels['outubro'] },
    { value: '11', label: labels['novembro'] },
    { value: '12', label: labels['dezembro'] },
]

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setExercicioDespesasPorOrgao: ['exercicio'],
    setMesDespesasPorOrgao: ['mes'],
    setAdministracoesDespesasPorOrgao: ['administracoes'],
    setOrgaosDespesasPorOrgao: ['orgaos'],
    setFuncoesDespesasPorOrgao: ['funcoes'],
    setSubFuncoesDespesasPorOrgao: ['subFuncoes'],
    setDespesasDespesasPorOrgao: ['despesas'],
    setRecursosVinculadosDespesasPorOrgao: ['recursosVinculados'],
    setRecursosDestinacaoDespesasPorOrgao: ['recursosDestinacao'],
    limpaFiltroDespesasPorOrgao: [],
    receberFiltroDespesasPorOrgao: ['filtroRecebido'],
})

const INITIAL_STATE = {
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    mes: { value: (new Date().getMonth() + 1).toString(), label: meses[new Date().getMonth()].label },
    administracoes: [],
    orgaos: [],
    funcoes: [],
    subFuncoes: [],
    despesas: [],
    recursosVinculados: [],
    recursosDestinacao: [],
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setMes = (state = INITIAL_STATE, action) => {
    return { ...state, mes: action.mes }
}

const setAdministracoes = (state = INITIAL_STATE, action) => {
    return { ...state, administracoes: action.administracoes }
}

const setOrgaos = (state = INITIAL_STATE, action) => {
    return { ...state, orgaos: action.orgaos }
}

const setFuncoes = (state = INITIAL_STATE, action) => {
    return { ...state, funcoes: action.funcoes }
}

const setSubFuncoes = (state = INITIAL_STATE, action) => {
    return { ...state, subFuncoes: action.subFuncoes }
}

const setDespesas = (state = INITIAL_STATE, action) => {
    return { ...state, despesas: action.despesas }
}

const setRecursosVinculados = (state = INITIAL_STATE, action) => {
    return { ...state, recursosVinculados: action.recursosVinculados }
}

const setRecursosDestinacao = (state = INITIAL_STATE, action) => {
    return { ...state, recursosDestinacao: action.recursosDestinacao }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_DESPESAS_POR_ORGAO]: setExercicio,
    [Types.SET_MES_DESPESAS_POR_ORGAO]: setMes,
    [Types.SET_ADMINISTRACOES_DESPESAS_POR_ORGAO]: setAdministracoes,
    [Types.SET_ORGAOS_DESPESAS_POR_ORGAO]: setOrgaos,
    [Types.SET_FUNCOES_DESPESAS_POR_ORGAO]: setFuncoes,
    [Types.SET_SUB_FUNCOES_DESPESAS_POR_ORGAO]: setSubFuncoes,
    [Types.SET_DESPESAS_DESPESAS_POR_ORGAO]: setDespesas,
    [Types.SET_RECURSOS_VINCULADOS_DESPESAS_POR_ORGAO]: setRecursosVinculados,
    [Types.SET_RECURSOS_DESTINACAO_DESPESAS_POR_ORGAO]: setRecursosDestinacao,
    [Types.LIMPA_FILTRO_DESPESAS_POR_ORGAO]: limpaFiltro,
    [Types.RECEBER_FILTRO_DESPESAS_POR_ORGAO]: receberFiltro,
})
